export const getParkPageTitle = (park: string) =>
  park
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
